/* eslint-disable  */
import React, { useState } from "react";
import { Activity, FileText } from "react-feather";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { useAuth } from "../../../context/AuthContext";
import modulos from "../../../mocks/modulos";
import { ActivitiesInfoGeneral } from "../Actividades/index";
import FilemanagerInfoGeneral from "../FileManager";

let countToScroll = 0;
const Tabs = ({ entityId, activityComponent, filesComponent, clientId, isAdmin, isOwner, isAudit }) => {
  const { currentUser } = useAuth();
  const [activeTab, setActiveTab] = useState("1");

  const handleFilesChange = () => {
    filesComponent.current.refreshFiles();
    setActiveTab("1");
    activityComponent.current.refreshActivities();
  };
  const handleActivityChange = () => {
    activityComponent.current.refreshActivities();
  };
  return (
    <>
      <Nav tabs className="border-tab nav-primary justify-content-around  mb-2">
        <NavItem className="nav nav-tabs" role="tablist">
          <NavLink
            className={`${activeTab === "1" ? "active" : ""} px-2`}
            style={{ display: "grid", cursor: "pointer" }}
            onClick={() => {
              setActiveTab("1");
            }}
          >
            <span>
              <Activity size="24px" />
            </span>
            <small>Actividad </small>
          </NavLink>
        </NavItem>

        <NavItem className="nav nav-tabs" role="tablist">
          <NavLink
            className={`${activeTab === "2" ? "active" : ""} px-2`}
            style={{ display: "grid", cursor: "pointer" }}
            onClick={() => {
              setActiveTab("2");
              countToScroll++;
            }}
          >
            <span>
              <FileText size="24px" />
            </span>
            <small>Archivos</small>
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent activeTab={activeTab} className="p-0 h-100 mb-3 custom-scrollbar" style={{ overflow: "auto", maxHeight: "calc(100vh - 300px)" }}>
        <TabPane tabId="2" className="h-100">
          <FilemanagerInfoGeneral
            bodyStyle={{ overflow: "auto", paddingLeft: "10px", paddingRight: "10px", paddingTop: "10px" }}
            fileNameStyle={{ fontSize: "14px", fontWeight: "300" }}
            entity="infoGeneralClient"
            entityId={entityId}
            onChange={handleFilesChange}
            hideHeader
            clientId={clientId}
            ref={filesComponent}
            scroll={activeTab == "2" && countToScroll <= 1 ? true : false}
            editable={(isAdmin || isOwner) && !isAudit}
            canDeleteFile={(file) => isAdmin || (isOwner && currentUser && currentUser.user && file.usuarioItemId === currentUser.user.itemId)}
          />
        </TabPane>
        <TabPane tabId="1" className="h-100">
          <ActivitiesInfoGeneral
            ref={activityComponent}
            bodyStyle={{ overflow: "auto", paddingLeft: "10px", paddingRight: "10px" }}
            entityId={entityId}
            clientId={clientId}
            onChange={handleActivityChange}
            entity="infoGeneralClient"
            hideHeader
            activeTab={activeTab}
            scroll={false}
            editable={(isAdmin || isOwner) && !isAudit}
          />
        </TabPane>
      </TabContent>
    </>
  );
};

export default Tabs;
